import React from "react";
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';
import NewButton from 'common/components-v2/elements/button';


import { onClickAddToCalendar } from 'common/utils/utils';


const  AddToCalendar = ({
   date,
   title,
   description,
   className,
   buttonState,
   isNewVersion,
}) => {


   if(isNewVersion) {

      return (
         <NewButton
            buttonType='button'
            leftIconName='calendar-new'
            onClick={ () => onClickAddToCalendar(title, description, date) }
            size='small'
            text='Add to calendar'
            textClassName='!text-gray-900'
            type='outlined'
            buttonClassName='!bg-surface-front'
            { ...buttonState }
         />
      )
   }

   return (

      <div className={ className }>
         <Button
            text='Add to calendar'
            classNames='h-full px-3'
            padding='none'
            primaryColor
            onClick={ () => onClickAddToCalendar(title, description, date) }
            borderRadius='label'
            iconName='calendar'
            iconPosition='left'
            darkIconColor=''
            { ...buttonState }
         />
      </div>
   );
}
AddToCalendar.defaultProps = {
   className: 'h-5 mt-4 w-40',
   buttonState: {
      textSize: 'small',
      fontIconSize: 'small',
      backgroundColor: 'transparent',
   },
};
AddToCalendar.propTypes = {
   title: PropTypes.string,
   date: PropTypes.string,
   description: PropTypes.string,
   buttonState: PropTypes.object,
   className: PropTypes.string,
   isNewVersion: PropTypes.bool,
};
export default AddToCalendar
